export default __webpack_public_path__ + "static/media/8-bit-toad-bw@3x.420ee389.png";